import { useContext, useCallback } from "react"
import AuthContext from "store/context/PublicContext"
import { AppContext } from "store/context/AppContext"
import useCancelToken from "hooks/useCancelToken"
import { post_module_orch_action_middleware } from "services/middleware_services"

interface IPostLoadParams {
  body: any
  [key: string]: any
}

const useOrchResources = () => {
  const { newCancelToken } = useCancelToken()
  const {
    user: { token },
  } = useContext(AuthContext)
  const { loading_app, set_loading_app } = useContext(AppContext)

  const post_get_schedule_orders_action = useCallback(
    async ({ body }: IPostLoadParams) => {
      return await post_module_orch_action_middleware(`schedule`, body, token, newCancelToken())
    },
    [token, newCancelToken],
  )

  const post_source_items_inventory_by_channel_action = useCallback(
    async ({ body, channel }: IPostLoadParams) => {
      return await post_module_orch_action_middleware(
        `inventory/item/all/channel/${channel}?sourceGroup=true`,
        body,
        token,
        newCancelToken(),
      )
    },
    [token, newCancelToken],
  )

  return {
    post_get_schedule_orders_action,
    post_source_items_inventory_by_channel_action,
    loading_app,
    set_loading_app,
  }
}

export default useOrchResources
